import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AppShell from "../components/Layout/AppShell";
import App from "../App";
import "../index.css";
import "../styles/ui-system-premium.css";

import { ThemeProvider } from "../contexts/ThemeContext";
import { BrandThemeProvider } from "../contexts/BrandThemeContext";
import { AuthProvider } from "../contexts/AuthContext";
import { AuthoritySessionBoundary } from "../components/auth/AuthoritySessionBoundary";
import { AppearanceProvider } from "../contexts/AppearanceContext";
import { EncryptionProvider } from "../contexts/EncryptionContext";
import { PresenceProvider } from "../contexts/PresenceContext";
import { ToastProvider } from "../components/ToastSystem";
import { WebSocketProvider } from "../contexts/WebSocketContext";
import { DataSyncProvider } from "../contexts/DataSyncContext";
import { TooltipProvider } from "../components/Tooltip";
import { initMonitoring } from '../services/MonitoringService';
declare const __APP_DEPLOY_ID__: string;

initMonitoring({ release: __APP_DEPLOY_ID__ });

const container = document.getElementById("root") as HTMLElement | null;
if (!container) {
  throw new Error('Root element with id="root" not found in index.html');
}

const root = createRoot(container);

const app = (
  <ThemeProvider>
    <BrandThemeProvider>
      <AuthProvider>
        <AppearanceProvider>
          <AuthoritySessionBoundary>
            <EncryptionProvider>
              <PresenceProvider>
                <ToastProvider>
                  <WebSocketProvider>
                    <DataSyncProvider>
                      <TooltipProvider>
                        <AppShell>
                          <App />
                        </AppShell>
                      </TooltipProvider>
                    </DataSyncProvider>
                  </WebSocketProvider>
                </ToastProvider>
              </PresenceProvider>
            </EncryptionProvider>
          </AuthoritySessionBoundary>
        </AppearanceProvider>
      </AuthProvider>
    </BrandThemeProvider>
  </ThemeProvider>
);

// Use StrictMode only in dev to avoid double-invoking effects in production
root.render(import.meta.env.DEV ? <StrictMode>{app}</StrictMode> : app);

// Once React mounts, remove the static fallback to avoid duplicate content
queueMicrotask(() => {
  const fallback = document.getElementById('fallback-container');
  if (fallback && fallback.parentElement) {
    fallback.parentElement.removeChild(fallback);
  }
});

// Cleanly unmount on Vite HMR to prevent duplicate trees
if (import.meta.hot) {
  import.meta.hot.dispose(() => root.unmount());
}
